import { authenticatedFastApiAxiosInstance } from "@/lib/data/http";
import type { APIResponse } from "@/lib/types";
import type {
  CreateDashboardTab,
  DashboardTabView,
  DashboardTabOrderEntry,
  MatterDashboardTab,
  UpdateDashboardTab,
} from "@/lib/types/MatterDashboardTab";

const route = "matters/v2/dashboard-tabs";

export const retrieveDashboardTabs = async (view: DashboardTabView) =>
  authenticatedFastApiAxiosInstance
    .get<APIResponse<MatterDashboardTab[]>>(route, { params: { view } })
    .then((response) => response.data);

export const createDashboardTab = async (body: CreateDashboardTab) =>
  authenticatedFastApiAxiosInstance
    .post<APIResponse<MatterDashboardTab>>(route, body)
    .then((response) => response.data);

export const updateDashboardTab = async ({ id, ...body }: UpdateDashboardTab) =>
  authenticatedFastApiAxiosInstance
    .patch<APIResponse<MatterDashboardTab>>(`${route}/${id}`, body)
    .then((response) => response.data);

export const reorderDashboardTabs = async (tabs: DashboardTabOrderEntry[]) =>
  authenticatedFastApiAxiosInstance
    .patch<APIResponse<MatterDashboardTab[]>>(`${route}/order`, { tabs })
    .then((response) => response.data);

export const deleteDashboardTab = async ({
  id,
  dateModified,
}: Pick<MatterDashboardTab, "id" | "dateModified">) =>
  authenticatedFastApiAxiosInstance
    .delete<APIResponse<MatterDashboardTab>>(`${route}/${id}`, {
      params: { dateModified },
    })
    .then((response) => response.data);
